'use strict';

module.exports = {
    footerSignUp: function (dialog) {
        $('form.footer-email-signup').on('submit', function (e) {
            e.preventDefault();
            const form = $(this);
            form.spinner().start();
            $('.footersubscribe-success, .footersubscribe-error').addClass('d-none').html('');
            $.post(form.data('action'), form.serialize(), function (data) {
                if (data && data.success) {
                    $('body').trigger('footer:emailSignup', {eventAction: 'form submitted'});
                    $('.footersubscribe-success').html(data.message).removeClass('d-none');
                    form.spinner().stop();
                } else {
                    $('body').trigger('footer:emailSignup', {eventAction: 'form errored'});
                    $('.footersubscribe-error').html(data.message).removeClass('d-none');
                    form.spinner().stop();
                }
            }, 'json');
        });
    }
};
